// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/page_view.proto" (package "bianka.event.activity.v2", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../core/enrichment/organization";
import { User } from "../../../core/enrichment/user";
import { Order } from "../../../core/enrichment/order";
import { Gig } from "../../../core/enrichment/gig";
import { Page } from "../../../common/activity/v1/page";
/**
 * Next serial number to be used: 9
 *
 * @generated from protobuf message bianka.event.activity.v2.PageView
 */
export interface PageView {
    /**
     * The type of the page viewed
     *
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * Data regarding the page viewed
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page page = 2;
     */
    page?: Page;
    /**
     * Data regarding current session localization
     *
     * @generated from protobuf field: bianka.event.activity.v2.PageView.Localization localization = 3;
     */
    localization?: PageView_Localization;
    /**
     * Enrichments
     *
     * @generated from protobuf field: bianka.core.enrichment.Gig gig = 4;
     */
    gig?: Gig;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Order order = 5;
     */
    order?: Order;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User user = 6;
     */
    user?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User buyer = 7;
     */
    buyer?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User seller = 8;
     */
    seller?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 9;
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.PageView.Localization
 */
export interface PageView_Localization {
    /**
     * The domain / language of the Fiverr site (e.g. fr.fiverr.com, de.fiverr.com, pt.fiverr.com, etc.)
     *
     * @generated from protobuf field: optional string experience_locale = 1;
     */
    experienceLocale?: string;
    /**
     * The text formatting language (e.g. for UK users the formatting locale will be ‘en-GB’ and for America users it will be ‘en-US’)
     *
     * @generated from protobuf field: optional string formatting_locale = 2;
     */
    formattingLocale?: string;
    /**
     * The currency in which the user sees the prices on the site (e.g. dollar, euro, pound, etc.)
     *
     * @generated from protobuf field: optional string display_currency = 3;
     */
    displayCurrency?: string;
    /**
     * The language the user is assumed to speak (infers from on the request's context)
     *
     * @generated from protobuf field: optional string visitor_assumed_language = 4;
     */
    visitorAssumedLanguage?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PageView$Type extends MessageType<PageView> {
    constructor() {
        super("bianka.event.activity.v2.PageView", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "bianka.core.extension.required": true } },
            { no: 2, name: "page", kind: "message", T: () => Page },
            { no: 3, name: "localization", kind: "message", T: () => PageView_Localization },
            { no: 4, name: "gig", kind: "message", T: () => Gig },
            { no: 5, name: "order", kind: "message", T: () => Order },
            { no: 6, name: "user", kind: "message", T: () => User },
            { no: 7, name: "buyer", kind: "message", T: () => User },
            { no: 8, name: "seller", kind: "message", T: () => User },
            { no: 9, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.PageView
 */
export const PageView = new PageView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageView_Localization$Type extends MessageType<PageView_Localization> {
    constructor() {
        super("bianka.event.activity.v2.PageView.Localization", [
            { no: 1, name: "experience_locale", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "formatting_locale", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_currency", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "visitor_assumed_language", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.PageView.Localization
 */
export const PageView_Localization = new PageView_Localization$Type();
